<template>
  <div>
    <v-container class="mt-1" style="max-width: 850px">
      <v-card>
        <v-card-title>C21 redirect Page </v-card-title>
        <v-card-text>
          <h2>Click the button below to connect to the API and fetch data:</h2>
           <v-text-field
                    placeholder="Enter List ID"
                    label="List ID"                   
                    v-model="listID"
                  />
        </v-card-text>
        <v-card-actions>
          <v-btn @click="Connect" outlined rounded text> Connect API </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
        listID: null
    };
  },
  methods:{
    Connect(){
        
    }
  }
};
</script>
